import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {useTheme} from '@mui/material/styles';
import classNames from './SuccessMessage.module.css'

export const SuccessMessage = () => {
    const theme = useTheme()

    return (
        <Stack alignItems="center" className={classNames.root}>
            <CheckCircleIcon color="success" className={classNames.icon}/>
            <Typography variant="h4" color={theme.palette.success.main}>
                Thank you
            </Typography>
            <Typography>
                Our team will be in touch with you shortly.
            </Typography>
        </Stack>
    )
}